module.exports = __webpack_public_path__ + "static/media/ehealth_minor_reg_banner_desktop.3a18f63e.jpg";